// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__onDwe","banner_item":"Banner_banner_item__GGDGv","banner_box":"Banner_banner_box__Dq9qk"};